import { useIsMutating } from "@tanstack/react-query";

export const useIsUpdatingResource = ({
  resource,
  locale,
  id,
}: {
  resource: string;
  locale: string;
  id: string;
}) => {
  const creatingCount = useIsMutating({
    mutationKey: [resource, "updateOne"],
    predicate: (mutation) => {
      return (
        mutation.state.variables.locale === locale &&
        mutation.state.variables.id === id
      );
    },
  });

  return creatingCount > 0;
};
